import determineState from 'lib/reducers/determineState';

const reduceLibStateReset = () => determineState(null);

// noinspection JSUnusedGlobalSymbols
export default reduceLibStateReset;
